import React, { memo } from 'react';

import bn from '../../generalUtils/benames';
import CustomButton from './CustomButton';

const bemClass = bn.create('customColorPicker');

const CustomColorPicker = props => {
  const {
    id,
    onChange,
    className = '',
    resetClassName = '',
    isColorTextboxVisible = true,
    // style = undefined,
    disabled = false,
    resetColorOnClick,
    title = 'Color Picker',
    resetToolTip = 'Reset Color',
    label = '',
    readOnly = false,
    renderColorIcon = null,
    hideInput = false
  } = props;
  let { value } = props;
  if (!value) {
    value = '';
  }
  const removeSpaceLabel = label ? label.replace(/\s/g, '') : '';
  return (
    <div className={bemClass.b(className)}>
      {label && <span className="text-secondary-200 mb-1 w-9r d-block">{label}</span>}
      <div className="d-flex align-items-center position-relative">
        {isColorTextboxVisible && (
          <>
            <input
              id={`txtcolorcode_${removeSpaceLabel}`}
              type="text"
              maxLength={9}
              value={value}
              onChange={onChange}
              className={`form-control pl-1 w-9r ${readOnly ? 'readonly' : ''}`}
              readOnly={readOnly}
            />
            <span />
          </>
        )}
        {renderColorIcon && (
          <label htmlFor={id ? id : `${id || label}`} title={title} className='mb-0'>
            {renderColorIcon}
          </label>
        )}
        <input
          type="color"
          id={id ? id : `txtcolorpicker_${id || label}`}
          value={value || '#000000'}
          onChange={readOnly ? () => {} : onChange}
          disabled={disabled || readOnly}
          className="colorpicker"
          title={title}
          readOnly={readOnly}
          style={
            hideInput
              ? {
                  opacity: 0,
                  width: 0,
                  height: 0,
                  position: 'absolute'
                }
              : isColorTextboxVisible
              ? { position: 'absolute', right: resetColorOnClick ? '1.4rem' : '0', top: '2.5px' }
              : undefined
          }
        />
        {resetColorOnClick && (
          <CustomButton
            id={`btnresetcolor_${removeSpaceLabel}`}
            title={resetToolTip}
            className={`resetBan ${resetClassName}`}
            onClick={resetColorOnClick}
          >
            <i className="fa fa-ban text-danger" />
          </CustomButton>
        )}
      </div>
    </div>
  );
};

CustomColorPicker.displayName = 'CustomColorPicker';
export default memo(CustomColorPicker);
